// eslint-disable-next-line import/prefer-default-export
export enum SMTPIMAP {
  SMTP = 'SMTP',
  IMAP = 'IMAP',
}
